import React, { useContext, useEffect, useState } from 'react'
import { row1List, row2List, row3List, row4List, row5List, row6List } from './mockData/fakeData';
import DataQualityTable from './DataQualityTable';
import { useTranslation } from 'react-i18next';
import PrimeDialog from '../../../components/dialog/PrimeDialog';
import FiveRatingForm from './FiveRatingForm';
import { Button } from 'primereact/button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DataQualityMatrixTable from './DataQualityMatrixTable';
import ProductDataQualityScore from './ProductDataQualityScore';
import { calcCarbonProductQualtity, queryCarbonDataQualtity, queryDataQualtityMatrix, updateCarbonDataQualtity } from '../../../utility/service/carbonFootprint-service';
import { SystemLoading,checkLoading } from '../../../store/loadingStore';
import { checkDpSuccess } from '../../../utility/service/tool-service';
import { useOutletContext } from 'react-router-dom';
import { MessageContext,handleSuccessMessage } from '../../../store/messageStore';

const DataQualityTabPanel = ({
  productType,
  getValues,
  reset,
  control,
  register,
  errors,
  itemObj,
  setValue,
  setItemObj,
  isEditable


}) => {

  const [rows, setRows] = useState([]);
  const { t } = useTranslation();
  const [addDialog, setAddDialog] = useState(false);
  const [editAction, setEditAction] = useState('add');
  const [currentObj, setCurrentObj] = useState({});
  const [matrixDialog, setMatrixDialog] = useState(false);
  const [scoreDialog, setScoreDialog] = useState(false);
  const [, loading] = useContext(SystemLoading);
  const [, dispatch] = useContext(MessageContext); //訊息視窗  
  const [carbonDataId,setCarbonDataId] = useState('');
  const [dataQualtityObj,setDataQualtityObj] = useState({});
  const [rowsMatrix,setRowsMatrix] = useState([]);
  const [maxLevels,setMaxLevels] = useState(5);

  useEffect(()=>{
    axios_queryCarbonDataQualtity({carbonFpId:itemObj?.carbonFpId});
  },[])

  const axios_queryCarbonDataQualtity = (reqBody,readMore=false)=>{
          checkLoading(loading);
          queryCarbonDataQualtity(reqBody)
                .then((res)=>{
                  if(checkDpSuccess(res)){
                    let data =  res?.data?.RespBody?.cftDatas;
                    let resBody = res?.data?.RespBody;
                    setDataQualtityObj({
                      avgReliability:resBody?.avgReliability,
                      avgIntegrity:resBody?.avgIntegrity,
                      dqr:resBody?.dqr
                    })
                    setItemObj((pre)=>{
                      return{
                        ...pre,
                        productReliability:resBody?.ownReliability,
                        productIntegrity:resBody?.ownIntegrity
                      }
                    })
                    setValue("productReliability",resBody?.ownReliability?parseInt(resBody?.ownReliability):0);
                    setValue("productIntegrity",resBody?.ownIntegrity?parseInt(resBody?.ownIntegrity):0);
                    if(data?.length > 0){
                      setCarbonDataId(data[data?.length-1].carbonDataId);
                      if(readMore===true){
                        setRows((pre)=>{
                          return [...pre,...data] 
                        })
                      }else{
                        setRows((pre)=>{
                          return [...data]
                        });
                      }
                    }else{
                      if(readMore===false){
                        setRows([]);
                      }
                    }
                  }else{
                    if(readMore===false){
                      setRows([]);
                    }
                  }
                })
                .catch((err)=>{
                  console.log(err);
                })
                .finally(() => checkLoading(loading, false))
      }

  const editItem = (item) => {
    setCurrentObj(item);
    reset({
      ...item,
    })
    setAddDialog(true);
    setEditAction('edit');
  }

  const btnConfirm = () => {
    let reqBody = {
      carbonDataId:currentObj?.carbonDataId,
      reliabilityRemark:getValues("reliabilityRemark"),
      dataReliability:getValues("dataReliability"),
      coefReliability:getValues("coefReliability"),
      integrityRemark:getValues("integrityRemark"),
      dataIntegrity:getValues("dataIntegrity"),
      coefIntegrity:getValues("coefIntegrity"),
      timelinessRemark:getValues("timelinessRemark"),
      dataTimeliness:getValues("dataTimeliness"),
      coefTimeliness:getValues("coefTimeliness"),
      locationRemark:getValues("locationRemark"),
      dataLocation:getValues("dataLocation"),
      coefLocation:getValues("coefLocation"),
      technicalRemark:getValues("technicalRemark"),
      dataTechnical:getValues("dataTechnical"),
      coefTechnical:getValues("coefTechnical")
    }
    const skipZeroKeys = [
      'dataReliability',
      'coefReliability',
      'dataIntegrity',
      'coefIntegrity',
      'dataTimeliness',
      'coefTimeliness',
      'dataLocation',
      'coefLocation',
      'dataTechnical',
      'coefTechnical'
    ];

    const resultReqBody = Object.fromEntries(
      Object.entries(reqBody).filter(([key, value]) => {
        // 排除 undefined、null、''
        if (value === undefined || value === null || value === '') return false;
    
        // 特定欄位：如果值為 0 或 '0'，也排除
        if (skipZeroKeys.includes(key) && (value === 0 || value === '0')) return false;
    
        return true;
      })
    );
    updateCarbonDataQualtity(resultReqBody)
      .then((res)=>{
        if(checkDpSuccess(res)){
          setAddDialog(false);
          handleSuccessMessage(dispatch, t('button.update') + ' ' + t('message.success'));
          axios_queryCarbonDataQualtity({carbonFpId:itemObj?.carbonFpId});
        }
      })

  }

  const handleConfirmScore = () => {
    let productReliability = getValues("productReliability");
    let productIntegrity = getValues("productIntegrity");
    calcCarbonProductQualtity({
      carbonFpId:itemObj?.carbonFpId,
      productReliability,
      productIntegrity
    }).then((res)=>{
        if(checkDpSuccess(res)){
          setScoreDialog(false);
          axios_queryCarbonDataQualtity({carbonFpId:itemObj?.carbonFpId});
          setItemObj((pre)=>{
            return{
              ...pre,
              productReliability,
              productIntegrity
            }
          })

        }
      })
  }

  const axios_queryDataQualtityMatrix = ()=>{
    if(rowsMatrix?.length===0){
      queryDataQualtityMatrix()
      .then((res)=>{
      if(checkDpSuccess(res)){
          let data = res?.data?.RespBody
          setRowsMatrix(data);
          setMaxLevels(Math.max(...data.map(item => item.levelDescription.length)));
      }
      })
    }

    }

  return (
    <>

      <div className="flex justify-content-between flex-wrap align-items-center">
        <div className="align-items-start">
          <Button outlined label={t('dataQuatityMatrix')} onClick={() => { setMatrixDialog(true);axios_queryDataQualtityMatrix(); }}></Button>
        </div>
        <div className="align-items-end font-semibold">
          <Button 
            label={t('scoreCalculation')} 
            icon="pi pi-calculator"
            className="p-button-primary"
            onClick={() => {
              setScoreDialog(true);
            }}/>
        </div>
      </div>

      <DataQualityTable
        rows={rows}
        editItem={editItem}
      />

      <PrimeDialog
        scrollByBody={true}
        visible={addDialog}
        title={`${currentObj?.dataName} ${t('stage.dataQualtity')}`}
        size="lg"
        onClose={() => { setAddDialog(false) }}
        onConfirm={() => { btnConfirm(); }}
        disabledConfirm={!isEditable}
        bodyTemplate={
          <FiveRatingForm
            control={control}
            register={register}
            errors={errors}
            editAction={editAction}
            isEditable={isEditable}
          />}
      ></PrimeDialog>

      <PrimeDialog
        isShowConfBtn={false}
        scrollByBody={true}
        visible={matrixDialog}
        title={t('dataQuatityMatrix')}
        size="lg"
        onClose={() => { setMatrixDialog(false) }}
        onConfirm={() => { setMatrixDialog(false) }}
        bodyTemplate={<>
          <DataQualityMatrixTable rows={rowsMatrix} maxLevels={maxLevels}  />

        </>}>

      </PrimeDialog>

      <PrimeDialog
        scrollByBody={false}
        visible={scoreDialog}
        title={t('productDataQualtityScore')}
        size="lg"
        onClose={() => { setScoreDialog(false) }}
        onConfirm={() => { handleConfirmScore() }}
        disabledConfirm={!isEditable}
        bodyTemplate={<>
          <ProductDataQualityScore
            control={control}
            avgReliability={dataQualtityObj?.avgReliability}
            avgIntegrity = {dataQualtityObj?.avgIntegrity}
            dqr = {dataQualtityObj?.dqr}
            isEditable={isEditable}
          />

        </>}>

      </PrimeDialog>

    </>
  )
}

export default DataQualityTabPanel;